import React from 'react'
import { SkeletonAvatar, SkeletonCard, SkeletonBox } from '@offerzen/pinata-shame'

import styles from './styles'

const SkeletonJobCard = () => (
  <SkeletonCard aria-hidden="true" className={styles.card}>
    <SkeletonAvatar theme="dark" />
    <SkeletonBox theme="dark" size="medium" />
    <SkeletonBox theme="dark" size="medium" />
    <SkeletonBox theme="dark" size="medium" />
    <SkeletonBox theme="dark" size="medium" />
    <SkeletonBox theme="dark" size="medium" />
  </SkeletonCard>
)

export default SkeletonJobCard
